"use client";
import Link from "next/link";
import { ArrowRight } from "lucide-react";
import { Section, Container } from "@/components/ui/container";
import { Reveal } from "@/components/ui/reveal";
import { executiveSummary as data } from "@/lib/data/engine-narrative-generation";

export function ExecutiveSummary() {
  return (
    <Section id="executive-summary" className="relative">
      <Container>
        <Reveal>
          <div className="max-w-4xl">
            <span className="eyebrow-tiny text-[var(--color-purple)]">{data.eyebrow}</span>
            <h2 className="mt-3">{data.title}</h2>
          </div>
        </Reveal>
        <div className="mt-12 max-w-4xl space-y-5">
          {data.paragraphs.map((p, i) => (
            <Reveal key={i} delay={i * 60}>
              <p className="text-body leading-relaxed text-[rgb(var(--fg-muted))]">{p}</p>
            </Reveal>
          ))}
        </div>
        <Reveal delay={250}>
          <div className="mt-10">
            <Link href={data.cta.href} className="btn-primary-gradient h-12 px-7 inline-flex items-center gap-2 rounded-full font-semibold text-base">
              {data.cta.label} <ArrowRight className="h-4 w-4" />
            </Link>
          </div>
        </Reveal>
      </Container>
    </Section>
  );
}
